import React, { PropsWithChildren } from 'react';

import { css, cx } from '@emotion/css';
import { ToggleButton as MuiToggleButton, Theme } from '@mui/material';

import { useStyles } from '@/hooks/useStyles.ts';
import { PaletteColors } from '@/theme/PaletteOverrides.ts';

import { AtomProps } from './utils/AtomTypes';

export type BaseToggleButtonProps = PropsWithChildren<{
  value: string;
  color?: PaletteColors;
  toggled: boolean;
  onToggle: () => void;
  className?: string;
}>;

export type ToggleButtonProps = AtomProps<BaseToggleButtonProps>;

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  toggled,
  onToggle,
  children,
  className,
  ...props
}) => {
  const styles = useStyles(makeStyles);
  return (
    <MuiToggleButton
      size="small"
      className={cx(styles.container, className)}
      selected={toggled}
      onClick={onToggle}
      {...props}
    >
      {children}
    </MuiToggleButton>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    padding: theme.spacing(1, 4),
  }),
});
